import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 100c27.1 0 49-21.9 49-49S127.1 2 100 2 51 23.9 51 51s21.9 49 49 49zm34.3 12.2h-6.4c-8.5 3.9-18 6.1-27.9 6.1s-19.4-2.2-27.9-6.1h-6.4c-28.4 0-51.5 23-51.5 51.4v15.9c0 10.1 8.2 18.4 18.4 18.4h134.8c10.1 0 18.4-8.2 18.4-18.4v-15.9c0-28.3-23.1-51.4-51.5-51.4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}